import { format, parseISO } from "date-fns";

export const formatDateTime = (date) => {
    if (!date) return "";

    const parsedDate = date instanceof Date ? date : parseISO(date);

    return format(parsedDate, "yyyy-MM-dd HH:mm");
};

export const formatDateTimeString = (date) => {
    if (!date) return "";

    const parsedDate = date instanceof Date ? date : parseISO(date);

    return new Intl.DateTimeFormat("en-GB", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    }).format(parsedDate);
};

export const formatDate = (date) => {
    if (!date) return "";

    const parsedDate = date instanceof Date ? date : parseISO(date);

    return format(parsedDate, "yyyy-MM-dd");
};

export const formatTime = (date) => {
    if (!date) return "";

    const parsedDate = date instanceof Date ? date : parseISO(date);

    return format(parsedDate, "HH:mm");
};

export const formatDuration = (date) => {
    if (!date) return "";

    const parsedDate = date instanceof Date ? date : parseISO(date);

    const hours = parsedDate.getUTCHours();
    const minutes = parsedDate.getUTCMinutes();

    return `${hours}h ${minutes}m`;
};
